import styled from "styled-components/macro";

export const Container = styled.div`
  position: fixed;
  bottom: 0px;
  right: calc(50% - 150px);
  z-index: 100000000;
  background: var(--menu-color);
  border-radius: 25px 25px 0 0;
  width: 290px;
  padding: 0 25px;
  height: 89px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
  text-align: center;

  .new {
    position: relative;
    top: -22px;
    display: flex;
    gap: 8px;
    align-items: center;
    margin: auto;
    justify-content: space-around;

    &:hover {
      .text {
        opacity: 1;
      }
    }

    .area {
      position: relative;
      top: 35px;
      transition: all 0.25s;
      height: 500px;

      .text {
        opacity: 0;
        transition: all 0.45s;
        color: var(--grey-1);
      }

      &:hover {
        top: 10px;

        .text {
          opacity: 1;
        }

        a {
          top: 0;
          /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3), 0px 6px 12px rgba(0, 0, 0, 0.2);         */
        }
      }

      .symbol {
        color: var(--canvas-cta);
        margin: auto;
        background: var(--menu-color);
        display: block;
        border: 1px solid var(--grey-2);
        width: 90px;
        height: 60px;
        font-size: 25px;
        font-weight: 500;
        font-family: Inter;
        line-height: 58px;
        margin-bottom: 12px;

        svg {
          margin-top: 18px;
        }
      }

      &.label {
        .symbol {
          width: 80px;
          position: relative;
          color: var(--canvas-cta);
          font-size: 35px;
          font-weight: 700;
          border-color: var(--grey-2);
        }
      }
    }
  }
`;
